import PropTypes from 'prop-types'
import React from 'react'

import { privacy as privacyRoute, terms as termsRoute } from 'routes'

import { LinkStyled, TextLHStyled } from './styles'

const CheckboxTermsRu = ({
  locale,
  agreementText,
  privacy,
  privacyText,
  terms,
  termsText,
}) => {
  const privacyLink = privacy ? privacy : privacyRoute.as(locale)
  const termsLink = terms ? terms : termsRoute.as(locale)
  const parts = agreementText.split(/(<%= privacy %>|<%= terms %>)/)

  return (
    <>
      {parts.filter(Boolean).map((part, index) => {
        if (part === '<%= privacy %>' && privacyText) {
          return (
            <LinkStyled
              key={`privacy-${index}`}
              component="a"
              isTargetBlank={true}
              to={privacyLink}
              asPath={privacyLink}
            >
              <TextLHStyled dangerouslySetInnerHTML={{ __html: privacyText }} />
            </LinkStyled>
          )
        }

        if (part === '<%= terms %>' && termsText) {
          return (
            <LinkStyled
              key={`terms-${index}`}
              component="a"
              isTargetBlank={true}
              to={termsLink}
              asPath={termsLink}
            >
              <TextLHStyled dangerouslySetInnerHTML={{ __html: termsText }} />
            </LinkStyled>
          )
        }

        return (
          <TextLHStyled
            key={`text-${index}`}
            dangerouslySetInnerHTML={{
              __html: part,
            }}
          />
        )
      })}
    </>
  )
}

CheckboxTermsRu.propTypes = {
  locale: PropTypes.string.isRequired,
  agreementText: PropTypes.string.isRequired,
  privacy: PropTypes.string,
  privacyText: PropTypes.string,
  terms: PropTypes.string,
  termsText: PropTypes.string,
}

export default React.memo(CheckboxTermsRu)
